import { render, staticRenderFns } from "./employeeTurnoverTask.vue?vue&type=template&id=0df986f5&scoped=true"
import script from "./employeeTurnoverTask.vue?vue&type=script&lang=js"
export * from "./employeeTurnoverTask.vue?vue&type=script&lang=js"
import style0 from "./employeeTurnoverTask.vue?vue&type=style&index=0&id=0df986f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df986f5",
  null
  
)

export default component.exports